export default {
  logocropped: require('../assets/images/Logocropped.png'),
  cashplanit: require('../assets/images/CashPlanit.png'),
  logo: require('../assets/images/Logo.png'),
  endingbalance: require('../assets/images/Endingbalance.png'),
  product: require('../assets/images/Product.png'),
  endingprofit: require('../assets/images/Endingprofit.png'),
  operating: require('../assets/images/Operating.png'),
  finance: require('../assets/images/Finance.png'),
  startingbalance: require('../assets/images/Startingbalance.png'),
  payrol: require('../assets/images/Payrol.png'),
  logotext: require('../assets/images/LogoText.png'),
  chatlogo: require('../assets/images/Chatlogo.png'),
};
